import { createContext, useContext } from 'react';

export interface AiAssistantContextType {
    isOpen: boolean;
    isMinimized: boolean;
    openAssistant: () => void;
    closeAssistant: () => void;
    setIsMinimized: (val: boolean) => void;
    onTemplateCreated: ((template: unknown) => void) | null;
    setTemplateCreatedCallback: (callback: ((template: unknown) => void) | null) => void;
}

export const AiAssistantContext = createContext<AiAssistantContextType | undefined>(undefined);

export function useAiAssistant() {
    const context = useContext(AiAssistantContext);
    if (context === undefined) {
        throw new Error('useAiAssistant must be used within an AiAssistantProvider');
    }
    return context;
}
